import { render, staticRenderFns } from "./DeliveriesInbox.vue?vue&type=template&id=0c59db44&scoped=true&"
import script from "./DeliveriesInbox.vue?vue&type=script&lang=js&"
export * from "./DeliveriesInbox.vue?vue&type=script&lang=js&"
import style0 from "./DeliveriesInbox.vue?vue&type=style&index=0&id=0c59db44&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c59db44",
  null
  
)

export default component.exports